import React from "react";

const JQuery_Callback = () => {
  return (
    <div>
      <h1>JQuery_Callback</h1>
      <p>Placeholder component for: "JQuery_Callback"</p>
    </div>
  );
};

export default JQuery_Callback;
